define(['jquery', 'matchSize'], ($, matchSize) => {
    return {
        settings: {
            $body: $('body'),
            $pageHeader: $('#stickyHeaderNav'),
            $pageTop: $('#pageHeaderTop'),
            $pageFooter: $('#pageFooter'),
        },

        init() {
            this.bindEvents();
            this.initSticky();
        },

        bindEvents() {
            this.settings.$body.on('resize-body', this.initResize.bind(this));
        },

        resetStickyHeader() {
            if (!this.settings.$pageHeader.closest('.sticky-wrapper').length) {
                return;
            }

            this.settings.$pageHeader.off('sticky-start').off('sticky-end');
            this.settings.$pageHeader.unstick();
            this.settings.$pageHeader.insertAfter(this.settings.$pageTop);
            $('.sticky-wrapper').remove();
        },

        closeOpenedPopup() {
            this.settings.$body.trigger('header.popup.close');
        },

        initSticky() {
            this.resetStickyHeader();

            if (!matchSize().desktop) {
                return;
            }

            require(['sticky'], () => {
                this.settings.$pageHeader.sticky({
                    topSpacing: 0,
                    bottomSpacing: this.settings.$pageFooter.height(),
                });

                this.settings.$pageHeader.sticky('update');

                this.settings.$pageHeader.on('sticky-start', () => {
                    this.closeOpenedPopup();
                });

                this.settings.$body.css('height', 'auto');
            });
        },

        initResize() {
            this.initSticky();
        },
    };
});
